import { request } from '~/services/common';

import { makeCustomerCommunicationV1URL } from './customerCommunicationRequestUtils';

async function requestGetMessageArchiveRenderedHtml(id: string): Promise<string> {
  if (!id) {
    throw new Error('missing id');
  }

  const url = makeCustomerCommunicationV1URL(`/message-archives/rendered-html?id=${encodeURIComponent(id)}`);

  return request(url.toString(), {
    method: 'GET',
    credentials: 'include',
    renderHtml: true,
  });
}

export default requestGetMessageArchiveRenderedHtml;
